import styled, { css } from 'styled-components';

export const ListWrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0px;
    max-height: 400px;
    max-width: 940px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0px;
    width: 100%;

    &::-webkit-scrollbar {
      width: 15px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
      border-radius: 40px;
      outline: ${theme.v2.colors.neutral.highMedium} solid 1px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highLight};
      border-radius: 40px;
      border: 2px solid ${theme.v2.colors.neutral.highPure};
      cursor: pointer;
      width: calc(100% - 4px);
    }
  `}
`;
